import { createContext, useContext } from 'react'

export const DbContext = createContext(null)

export const useDbContext = () => {
  // console.log('using db conexte')
  return useContext(DbContext)
}
